import React from "react";
import { Box, Tooltip as ChakraTooltip } from "@chakra-ui/react";
export function Tooltip({ isDisabled, children, message }) {
    return (React.createElement(ChakraTooltip, { hasArrow: true, isDisabled: isDisabled, label: message, placement: "top", openDelay: 200, motionProps: {
            initial: {
                scale: 0.9,
                opacity: 0,
            },
            variants: {
                enter: {
                    scale: 1,
                    opacity: 1,
                    transition: {
                        type: "spring",
                        damping: 30,
                        stiffness: 1000,
                    },
                },
                exit: {
                    scale: 0.9,
                    opacity: 0,
                    transition: {
                        type: "spring",
                        duration: 0.15,
                    },
                },
            },
        } },
        React.createElement(Box, { as: "span", display: "inline-block", tabIndex: 0, width: "max-content", height: "max-content" }, children)));
}
